import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/timeSort.png'


const _withScopeId = n => (_pushScopeId("data-v-70b3f1f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ub fw ub-ac ub-pc zhezhao"
}
const _hoisted_2 = {
  key: 1,
  class: "table-header ub ub-ps ub-ac fw"
}
const _hoisted_3 = {
  key: 2,
  class: "ub spaceBetween"
}
const _hoisted_4 = {
  key: 3,
  class: "ub spaceBetween"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 123")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"14px","height":"14px","margin-left":"calc(100% - 120px)","cursor":"pointer"}
}, null, -1))
const _hoisted_7 = { style: {"text-align":"right"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("清除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_10 = {
  key: 4,
  class: "pager-container"
}
const _hoisted_11 = {
  key: 0,
  class: "pager-inline-footer table-footer ub ub-ps ub-ac fw"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_editableCell = _resolveComponent("editableCell")!
  const _component_SettingOutlined = _resolveComponent("SettingOutlined")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_sort_icon = _resolveComponent("sort-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_vxe_colgroup = _resolveComponent("vxe-colgroup")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["component-table-list-wrapper", _ctx.className])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_a_spin, {
            spinning: _ctx.loading,
            class: "ub spin-loading"
          }, null, 8, ["spinning"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasHeaderSlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "header", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasButtonsSlot && _ctx.showButtons)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_a_space, {
            size: 10,
            style: {"margin-bottom":"10px"},
            class: "table-buttons-a-space"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "buttons", {}, undefined, true)
            ]),
            _: 3
          }),
          (_ctx.showEditCell)
            ? (_openBlock(), _createBlock(_component_editableCell, {
                key: 0,
                columns: _ctx.computedColumns,
                xTable: _ctx.xTable1,
                onChangeColumns: _ctx.changeColumns,
                tabeleBizCode: _ctx.tabeleBizCode
              }, null, 8, ["columns", "xTable", "onChangeColumns", "tabeleBizCode"]))
            : _createCommentVNode("", true),
          (_ctx.showCustomSetting)
            ? (_openBlock(), _createBlock(_component_SettingOutlined, {
                key: 1,
                onClick: _ctx.setCol,
                style: { fontSize: '16px' }
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasButtonsBottomSlot)
      ? (_openBlock(), _createElementBlock("data", _hoisted_4, [
          _renderSlot(_ctx.$slots, "buttonsBottom", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_vxe_table, {
      class: "responsive-table a-table",
      id: "myCustomUpdate",
      border: _ctx.border,
      "show-header": _ctx.showHeader,
      ref: "xTable1",
      height: _ctx.newTableHeight,
      "max-height": _ctx.maxHeight,
      "row-config": { isCurrent: true, isHover: true, ..._ctx.rowConfig },
      "tooltip-config": { enterable: true, contentMethod: _ctx.tooltipContentMethod },
      "column-config": { resizable: true, maxFixedSize: 10 },
      data: _ctx.dataSource,
      "seq-config": _ctx.tableSeq,
      "footer-method": _ctx.tableConfig.footerMethod,
      "show-footer": _ctx.tableConfig.footerMethod ? true : false,
      "row-class-name": _ctx.tableConfig?.setRowClassName,
      "cell-class-name": _ctx.tableConfig?.setCellClassName,
      "checkbox-config": _ctx.newCheckboxConfig,
      onCustom: _ctx.customEvent,
      customConfig: _ctx.customConfig,
      "radio-config": _ctx.radioConfig,
      "edit-config": _ctx.editConfig,
      "resizable-config": {minWidth:0},
      onCheckboxAll: _ctx.selectChangeEvent,
      onCheckboxChange: _ctx.selectChangeEvent,
      onRadioChange: _ctx.radioChangeEvent,
      onCellClick: _ctx.cellClickEvent,
      onResizableChange: _ctx.resizableChange,
      "sort-config": { remote: true, trigger: 'cell', orders: ['desc', 'asc', null] },
      onSortChange: _ctx.sortChangeEvent
    }, {
      empty: _withCtx(() => [
        _renderSlot(_ctx.$slots, 'emptyTemplate', {}, () => [
          _createVNode(_component_a_empty, { image: _ctx.simpleImage }, {
            description: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["image"])
        ], true)
      ]),
      default: _withCtx(() => [
        (_ctx.showCheckbox && !_ctx.showRadiobox)
          ? (_openBlock(), _createBlock(_component_vxe_column, {
              key: 0,
              type: "checkbox",
              width: "50",
              fixed: _ctx.maxHeight ? '' : 'left',
              align: "center",
              "show-overflow": false
            }, null, 8, ["fixed"]))
          : _createCommentVNode("", true),
        (_ctx.showRadiobox)
          ? (_openBlock(), _createBlock(_component_vxe_column, {
              key: 1,
              type: "radio",
              width: "50",
              fixed: "left",
              align: "center",
              "show-overflow": false
            }))
          : _createCommentVNode("", true),
        (_ctx.expandSlot != '')
          ? (_openBlock(), _createBlock(_component_vxe_column, {
              key: 2,
              type: "expand",
              width: "50"
            }, {
              content: _withCtx(({ row, rowIndex, column, columnIndex }) => [
                _renderSlot(_ctx.$slots, _ctx.expandSlot, {
                  column: column,
                  record: row,
                  columnIndex: columnIndex
                }, () => [
                  _hoisted_5
                ], true)
              ]),
              _: 3
            }))
          : _createCommentVNode("", true),
        (_ctx.showSeq)
          ? (_openBlock(), _createBlock(_component_vxe_column, {
              key: 3,
              fixed: _ctx.maxHeight ? '' : 'left',
              type: "seq",
              field: "seq",
              width: "80",
              align: "center",
              title: "序号"
            }, null, 8, ["fixed"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedColumns, ({
          slots,
          type,
          key,
          title,
          dataIndex,
          fixed,
          width,
          align = 'left',
          titlePrefix = null,
          children = [],
          isShow = true,
          sort = false,
          visible = true,
        }) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (children.length == 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  isShow
                    ? (_openBlock(), _createBlock(_component_vxe_column, {
                        titlePrefix: titlePrefix,
                        "show-overflow": "tooltip",
                        field: key || dataIndex,
                        title: title,
                        fixed: fixed,
                        type: type,
                        width: _ctx.setMinWidth?null:(_ctx.flexFlag ? width : ''),
                        align: align,
                        "min-width": _ctx.setMinWidth?width:null,
                        key: key,
                        sortable: sort,
                        visible: visible
                      }, _createSlots({
                        default: _withCtx(({ row, rowIndex }) => [
                          _renderSlot(_ctx.$slots, key || dataIndex, {
                            record: row,
                            index: rowIndex
                          }, () => [
                            _createTextVNode(_toDisplayString(row[key] ? row[key] : row[dataIndex] ? row[dataIndex] : row[key] === 0 ? 0 : "-"), 1)
                          ], true)
                        ]),
                        _: 2
                      }, [
                        (
                slots &&
                slots?.title &&
                (key !== 'lastModifiedTime' || dataIndex !== 'lastModifiedTime')
              )
                          ? {
                              name: "header",
                              fn: _withCtx(({ column, columnIndex, $columnIndex, _columnIndex, $rowIndex }) => [
                                _renderSlot(_ctx.$slots, slots.title, {
                                  column: column,
                                  columnIndex: columnIndex
                                }, () => [
                                  _createTextVNode(_toDisplayString(title || ""), 1)
                                ], true)
                              ])
                            }
                          : undefined,
                        ((key == 'lastModifiedTime' || dataIndex == 'lastModifiedTime') && _ctx.timeSort)
                          ? {
                              name: "header",
                              fn: _withCtx(({ column, columnIndex, $columnIndex, _columnIndex, $rowIndex }) => [
                                _createElementVNode("span", {
                                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
                                }, "最近更新时间"),
                                _createVNode(_component_sort_icon, {
                                  isRest: _ctx.isRest,
                                  onOrderSort: _ctx.lastTimeSort
                                }, null, 8, ["isRest", "onOrderSort"]),
                                _hoisted_6,
                                _createVNode(_component_a_range_picker, {
                                  value: _ctx.lastTime,
                                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastTime) = $event)),
                                  class: "append-to-table",
                                  ranges: _ctx.ranges,
                                  format: "YYYY-MM-DD",
                                  "value-format": "YYYY-MM-DD",
                                  style: {"position":"absolute","left":"150px","top":"0px","opacity":"0","cursor":"pointer"},
                                  onChange: _ctx.timeChange
                                }, {
                                  renderExtraFooter: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_7, [
                                      _createVNode(_component_a_button, {
                                        size: "small",
                                        onClick: _ctx.clearTime,
                                        disabled: _ctx.lastTime.length == 0
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_8
                                        ]),
                                        _: 1
                                      }, 8, ["onClick", "disabled"])
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["value", "ranges", "onChange"])
                              ])
                            }
                          : undefined,
                        (slots && slots?.footer)
                          ? {
                              name: "footer",
                              fn: _withCtx(({ items, _columnIndex }) => [
                                _renderSlot(_ctx.$slots, slots.footer, {
                                  items: items,
                                  _columnIndex: _columnIndex
                                }, undefined, true)
                              ])
                            }
                          : undefined
                      ]), 1032, ["titlePrefix", "field", "title", "fixed", "type", "width", "align", "min-width", "sortable", "visible"]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  isShow
                    ? (_openBlock(), _createBlock(_component_vxe_colgroup, {
                        key: 0,
                        title: title,
                        align: align
                      }, _createSlots({
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (item['isShow'] != null ? item['isShow'] : true)
                                ? (_openBlock(), _createBlock(_component_vxe_column, {
                                    "show-overflow": "tooltip",
                                    field: item.key || item.dataIndex,
                                    title: item.title,
                                    fixed: item.fixed,
                                    type: item.type,
                                    width: item.width < 80 ? 80 : item.width,
                                    align: item.align,
                                    key: item.key
                                  }, _createSlots({
                                    default: _withCtx(({ row, rowIndex }) => [
                                      _renderSlot(_ctx.$slots, item.key || item.dataIndex, {
                                        record: row,
                                        index: rowIndex
                                      }, () => [
                                        _createTextVNode(_toDisplayString(row[item["key"]]
                        ? row[item["key"]]
                        : row[item.dataIndex]
                        ? row[item.dataIndex]
                        : row[item["key"]] === 0
                        ? 0
                        : "-"), 1)
                                      ], true)
                                    ]),
                                    _: 2
                                  }, [
                                    (item.slots && item.slots?.title)
                                      ? {
                                          name: "header",
                                          fn: _withCtx(({ row, rowIndex }) => [
                                            _renderSlot(_ctx.$slots, item.slots.title, {
                                              record: row,
                                              index: rowIndex
                                            }, undefined, true)
                                          ])
                                        }
                                      : undefined,
                                    (item.slots && item.slots?.footer)
                                      ? {
                                          name: "footer",
                                          fn: _withCtx(({ items, _columnIndex }) => [
                                            _renderSlot(_ctx.$slots, item.slots.footer, {
                                              items: items,
                                              _columnIndex: _columnIndex
                                            }, undefined, true)
                                          ])
                                        }
                                      : undefined
                                  ]), 1032, ["field", "title", "fixed", "type", "width", "align"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ]),
                        _: 2
                      }, [
                        (slots && slots?.title)
                          ? {
                              name: "header",
                              fn: _withCtx(({ column, columnIndex, $columnIndex, _columnIndex, $rowIndex }) => [
                                _renderSlot(_ctx.$slots, slots.title, {
                                  column: column,
                                  columnIndex: columnIndex
                                }, () => [
                                  _createTextVNode(_toDisplayString(title || ""), 1)
                                ], true)
                              ])
                            }
                          : undefined
                      ]), 1032, ["title", "align"]))
                    : _createCommentVNode("", true)
                ], 64))
          ], 64))
        }), 256))
      ]),
      _: 3
    }, 8, ["border", "show-header", "height", "max-height", "row-config", "tooltip-config", "data", "seq-config", "footer-method", "show-footer", "row-class-name", "cell-class-name", "checkbox-config", "onCustom", "customConfig", "radio-config", "edit-config", "onCheckboxAll", "onCheckboxChange", "onRadioChange", "onCellClick", "onResizableChange", "onSortChange"]),
    ((_ctx.dataSource && _ctx.dataSource.length > 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.hasFooterSlot)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_vxe_pager, {
            perfect: "",
            layouts: [
            'Total',
            'PrevPage',
            'Number',
            'NextPage',
            'Sizes',
            _ctx.showFullJump ? 'FullJump' : '',
          ],
            "current-page": _ctx.pagination.current,
            "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination.current) = $event)),
            "page-size": _ctx.pagination.pageSize,
            "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pagination.pageSize) = $event)),
            total: _ctx.pagination.total,
            pageSizes: [10, 15, 20, 50, 100,200,500],
            onPageChange: _ctx.onTableChange,
            style: {"height":"48px !important"}
          }, null, 8, ["layouts", "current-page", "page-size", "total", "onPageChange"]), [
            [_vShow, _ctx.pagination.pageSize > 0]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}